/**
 * 
 * (c) Use It Better, http://useitbetter.com
 *
 *
 * @preserve
 */
function getScriptUrl(){
    var source = document.querySelector('script[src*="udash."]').getAttribute('src');
    var name = source.split('/').pop(); 
    return source.replace(name,"");    
}

__webpack_public_path__ = getScriptUrl();

;(function(win) { // win === window

    if (win.uDash) {
        console.error("Attempt to initiate uDash terminated. It's been already initiated.");
        return;
    }
	'use strict';
    
	// object performing tests to determine if the browser is capable of handling uDash
	var _capabilities = {

		result: [],

		tests: { // test cases returning boolean value for passed or failed test
			'Element.addEventListener': function() {
				return	'addEventListener' in win;
			},
			'Date.now': function() {
				return 'now' in win.Date;
			},
			'String.trim': function() {
				return 'trim' in win.String.prototype;
			},
			'JSON': function() {
				return 'JSON' in win;
			},
			'localStorage': function() {
				return 'localStorage' in win;
			},
			'sessionStorage': function() {
				return 'sessionStorage' in win;
			},
			'Canvas.getContext': function() {
				return 'getContext' in win.document.createElement('canvas');
			}
		},

		check: function() {
			var name;

			for(name in this.tests) {
				if(this.tests.hasOwnProperty(name) && this.tests[name]() === false) { // failure
					this.result.push(name); // push failed test name into result array
				}
			}

			return this.result.length === 0; // if result array is empty then all the tests passed
		},

		getResult: function() {
			return this.result.join(', ');
		}

	};


	/* and here we go... */

	// before even publishing uDash object into global namespace, check browser capability
	if(_capabilities.check()) {
        
        var uShared = require("./ushared");
        
		var _publisher = {

			_uDashInitOptions: {},

			_inject: function(options) {

				if(uShared._sstorage.get('uDebug')) { 
					if(typeof uShared._uConsole.log === 'undefined') {
						uShared._uConsole.init(true);
					}
				} 
				// determine which object inject as uDash into global namespace
				if(uShared._sstorage.get('uHeatMapData')) { // uHeatMapData specified in url or saved in session, inject uHeatMap 
					if(typeof uShared._uConsole.log === 'undefined') {
						uShared._uConsole.init(true);
					}
                    
                    win.uDash = require("./urecorder");
				    win.uDash.init.call(win.uDash, options);   
                               
                    require.ensure(["./uheatmap"], function(require) {
                        var uHeatMap = require("./uheatmap");
                        win.uHeatMap = uHeatMap;
					    uHeatMap.init.call(win.uDash, options);
                    }, "uheatmap");
                    
				}
				else if(uShared._sstorage.get('uSessionHash') && uShared._sstorage.get('uProjectHash')) {
                    require.ensure(["./uplayer"], function(require) {
                        var uPlayer = require("./uplayer");
					    win.uDash = uPlayer;
                        win.uDash.init.call(win.uDash, options);
                    }, "uplayer");
				}
				else { // no uParams specified, inject uRecorder
					win.uDash = require("./urecorder");
                    win.uDash.init.call(win.uDash, options);
				}
                win.uDash.shared = uShared;
			},

			_checkMessage: function(e) {

				var	data = e.data,
					params = e.data.params;

				if(data && data.uDashMessage === true && params && typeof params.uParams === 'object') {

					uShared._timeouts.clear('publishTimeout');
					win.removeEventListener('message', _publisher._checkMessage);
					uShared._uParams.loadFromJSON(params.uParams);

					_publisher._inject(_publisher._uDashInitOptions);
				
				}
		
			},

			run: function() {

				var that = this;

				win.uDash = {
					
					META_ACTION: uShared.META_ACTION,
					META_SECTION: uShared.META_SECTION,
					META_ERROR: uShared.META_ERROR,
					META_SITE_IS_READY: uShared.META_SITE_IS_READY,

					init: function(options) {

						var bkp;

						that._uDashInitOptions = options;
                        uShared._defaults = uShared._extend(uShared._defaults,options);

						if(!uShared._uParams.loadFromUrl()) {
							
							// try to get backup data from storage if there is any
							if(
								options.uProjectName && options.uPort && options.uProjectApiPass &&
								(bkp = uShared._sstorage.getBackup(options.uProjectName, options.uPort, options.uProjectApiPass))
							) {
								// there is a valid recorder backup set	
                                if (bkp){
                                    if (bkp['inthesample']) uShared._lstorage.set('inthesample',bkp['inthesample']);
                                    if (bkp['outofsample']) uShared._lstorage.set('outofsample',bkp['outofsample']);
                                    if (bkp['userID']) uShared._lstorage.set('userID',bkp['userID']);
                                    if (bkp['userVisit']) uShared._lstorage.set('userVisit',bkp['userVisit']);
                                    if (bkp['logDumpToken']) uShared._sstorage.set('logDumpToken',bkp['logDumpToken']);
                                    if (bkp['timeOffset']) uShared._sstorage.set('timeOffset',bkp['timeOffset']);
                                    if (bkp['uDebug']) uShared._sstorage.set('uDebug',bkp['uDebug']);
                                }

							}
							if(win !== win.top) { // current document is in nested frame, possibly a replay, try getting data
								try {

									
                                    // origins are not the same, poll for possibility of communication
                                    win.addEventListener('message', that._checkMessage, false);

                                    win.parent.postMessage({
                                        uDashMessage: true,
                                        name: 'requestUParams'
                                    }, '*');

                                    // after 150ms it's unlikely that parent frame is a uPlayerWrapper and didn't respond yet, proceed with initialization
                                    uShared._timeouts.set('publishTimeout', function() {

                                        that._inject(options);

                                    }, 150);
									
								} //Access violation
								catch (err) {
									uShared._uConsole.log ('frame access',err);
									//document.domain = window.location.hostname.replace('www.', '');
									win.parent.postMessage({
										uDashMessage: true,
										name: 'changeDomain',
										href: window.location.href
									}, '*');
									
									setTimeout(win.uDash.init,500,options);
									return;
								}
							}
							else { // current document is a top frame
								that._inject(options);
							}
						}
						else { // no params loaded from URL
							that._inject(options);
						}
						
					},
					getSetting: function(name) {
						return uShared._defaults[name] || '';
					},
					getStatus: function() {
						return 'notready';
					},
					tearDown: function() { },
					saveAttribute: function() { },
					saveMeta: function() { },
					sendDump: function() { }
				};
				
			}
		};

		_publisher.run();

		
	}
	else { // if capability test failed, notify developer and inject blank object in order to not cause any errors
		
		if(win.console && win.console.log) {
			win.console.log('uDash: this browser is incapable of handling uDash properly. Failed support test(s) for: ' + _capabilities.getResult());
		}

		win.uDash = {
			META_ACTION: '',
			META_SECTION: '',
			META_ERROR: '',
			META_SITE_IS_READY: '',

			init: function() { },
			getSetting: function(name) {
				return '';
			},
			getStatus: function() {
				return 'incompatible';
			},
			tearDown: function() { },
			saveAttribute: function() { },
			saveMeta: function() { },
			sendDump: function() { }
		};
	}

}(window)); // passing global object as '"win"



//////////////////
// WEBPACK FOOTER
// ./udash.js
// module id = 0
// module chunks = 0